import React from 'react'

import { Tooltip } from 'slab'

export interface BadgeCellProps
  extends Omit<React.HTMLAttributes<HTMLTableCellElement>, 'className'> {
  children: React.ReactNode;
  info?: string;
}

export function BadgeCell ({ children, info, ...props }: BadgeCellProps) {
  const content = (
    <div className='px-4 py-2 rounded-t-lg inline-block bg-violet-50 text-violet-500 body-sm-bold'>
      {children}
    </div>
  )

  return (
    <td {...props} className='text-left'>
      {info
        ? (
          <Tooltip content={info}>{content}</Tooltip>
          )
        : (
            content
          )}
    </td>
  )
}
